/* Domowy Masazysta - kabel gratis: maksymalnie 1 szt. na 1 masazer w koszyku.
   Siatka bezpieczenstwa: po kazdej zmianie koszyka sprawdza ilosci i obcina kabel do liczby masazerow. */
(function () {
  'use strict';
  var CABLE = 'kabel-gratis';
  var NOT_MASSAGERS = [CABLE, 'opakowanie-prezentowe'];
  var nativeFetch = window.fetch.bind(window);
  var busy = false;

  function refreshUi() {
    if (/^\/cart\/?$/.test(window.location.pathname)) {
      window.location.reload();
      return Promise.resolve();
    }
    return nativeFetch('/?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        ['cart-drawer', 'cart-icon-bubble'].forEach(function (id) {
          var el = document.getElementById('shopify-section-' + id);
          if (!el || !sections[id]) return;
          var wasActive = false;
          var drawer = el.querySelector('cart-drawer');
          if (drawer) wasActive = drawer.classList.contains('active');
          var doc = new DOMParser().parseFromString(sections[id], 'text/html');
          var fresh = doc.querySelector('.shopify-section') || doc.body;
          el.innerHTML = fresh.innerHTML;
          var newDrawer = el.querySelector('cart-drawer');
          if (newDrawer && wasActive) newDrawer.classList.add('active');
        });
      })
      .catch(function () {});
  }

  function enforce() {
    if (busy) return;
    busy = true;
    nativeFetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var massagers = 0;
        var cable = null;
        cart.items.forEach(function (item) {
          if (item.handle === CABLE) cable = item;
          else if (NOT_MASSAGERS.indexOf(item.handle) === -1) massagers += item.quantity;
        });
        if (!cable || cable.quantity <= massagers) return false;
        return nativeFetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: cable.key, quantity: massagers })
        }).then(function () { return true; });
      })
      .then(function (changed) { return changed ? refreshUi() : null; })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var promise = nativeFetch.apply(window, arguments);
    if (/\/cart\/(add|change|update)(\.js)?(\?|$)/.test(url)) {
      promise.then(function () { setTimeout(enforce, 0); }, function () {});
    }
    return promise;
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enforce);
  else enforce();
  window.addEventListener('pageshow', enforce);
})();
